module.exports = __webpack_public_path__ + "img/t6.267a8a54.png";